export default {
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/mzcoupons.js